import SPANISH_STATE from '../resources/es.json'
import ENGLISH_STATE from '../resources/en.json'

type fn = () => void | any

const esLanguage = {
  lang: 'es',
  messages: SPANISH_STATE
}
const enLanguage = {
  lang: 'en',
  messages: ENGLISH_STATE
}
export const detectLanguage: fn = () => {
  const languageCookie = document.cookie.match(/language=([^;]+)/)?.[1] || 'en'
  const functionalityCookie = document.cookie.match(/functionalityCookies=([^;]+)/)?.[1]
  let initialState = languageCookie.includes('es') ? esLanguage : enLanguage
  if (functionalityCookie === 'true' && !localStorage.getItem('languageDetectedOnce')) {
    const language = (navigator.languages && navigator.languages[0]) || navigator.language
    initialState = language.includes('es') ? esLanguage : enLanguage
    localStorage.setItem('languageDetectedOnce', 'true')
  }
  return initialState
}
